<script lang="ts">
    export let image
    export let title
    export let text
    export let list = []
</script>

<div class="helper">
    <img src={image} alt="" />
    <div class="title">{title}</div>
    <div class="ontent">
        <p>{text || ''}</p>
        <ul>
            {#each list as item}
                <li>{item}</li>
            {/each}
        </ul>
    </div>
    <slot />
</div>

<style>
    .helper {
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 16px;
        font-weight: 300;
    }
    .helper img {
        height: 160px;
    }
    .helper .title {
        font-size: 36px;
    }
    .helper p {
        font-size: 20px;
    }
</style>
